import { AxiosError } from "axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Agent, AgentCreate } from "@/model";
import agentRepository from "@/repository/agentRepository";
import { agentQueryKeys } from "./keys";


export const useCreateAgent = () => {
    const queryClient = useQueryClient();

    return useMutation<Agent, AxiosError, AgentCreate>({
        mutationKey: ["agent", "create"],
        mutationFn: async (body: AgentCreate) => {
            try {
                const { data } = await agentRepository.create(body);
                return data?.data;
            } catch (e) {
                throw e;
            }
        },
        onSuccess: async () => {
            await queryClient.invalidateQueries({
                queryKey: agentQueryKeys.recent(),
                exact: false
            });
            await queryClient.invalidateQueries({
                queryKey: agentQueryKeys.pageAll(),
                exact: false
            });
        }
    });
};
